"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LintSeverity = void 0;
var LintSeverity;
(function (LintSeverity) {
    LintSeverity["Info"] = "info";
    LintSeverity["Warning"] = "warning";
    LintSeverity["Error"] = "error";
})(LintSeverity || (exports.LintSeverity = LintSeverity = {}));
